module.exports = __webpack_public_path__ + "assets/img/icon1.8555f752.png";